module.exports = __webpack_public_path__ + "img/lukoil-logo-en.c46e0279.svg";